import { z } from 'zod';
import { SafeStringSchema } from '../types/CommonSchemas';

export const FlightLogSchema = z.object({
    fileName: SafeStringSchema,
    fileSize: z.number(),
    logId: SafeStringSchema
});

export type FlightLogData = z.infer<typeof FlightLogSchema>;

export const FlightLogListSchema = z.array(FlightLogSchema);

export type FlightLogDataList = z.infer<typeof FlightLogListSchema>;

export const MultipleFlightLogsSchema = z.object({
    flightLog: FlightLogListSchema
});

export type MultipleFlightLogsData = z.infer<typeof MultipleFlightLogsSchema>;

export interface FlightLogGetFlightLogsRequestData {
    imei: string;
    page: number;
    count: number;
}
